module.exports = __webpack_public_path__ + "img/ai.442824e2.png";